import React from "react";
import stepsBg from "./images/three_steps_bg.png";
import step1Img from "./images/step1_signup.jpg";
import step2Img from "./images/step2_matches.jpg";
import step3Img from "./images/step3_connect.jpg";

const ThreeEasySteps = () => {
  return (
    <section className="three-easy-steps-section">
      <div className="steps-inner-container">
        {/* Top Heart & Golden Swirls Ornament */}
        <div className="steps-top-ornament">
          <svg width="150" height="24" viewBox="0 0 150 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 12C32 12 40 4 52 4C58 4 62 12 68 12" stroke="#d4a373" strokeWidth="1.2" strokeLinecap="round" />
            <path d="M135 12C118 12 110 4 98 4C92 4 88 12 82 12" stroke="#d4a373" strokeWidth="1.2" strokeLinecap="round" />
            <circle cx="26" cy="12" r="2.5" fill="#d4a373" />
            <circle cx="124" cy="12" r="2.5" fill="#d4a373" />
            <path d="M75 19L73.5 17.6C68.2 12.8 64.7 9.6 64.7 5.7C64.7 3.3 66.5 1.5 68.8 1.5C70.1 1.5 71.4 2.1 72.2 3.1L75 6.3L77.8 3.1C78.6 2.1 79.9 1.5 81.2 1.5C83.5 1.5 85.3 3.3 85.3 5.7C85.3 9.6 81.8 12.8 76.5 17.6L75 19Z" stroke="#e53d5c" strokeWidth="1.8" fill="none" />
          </svg>
        </div>

        {/* Section Heading */}
        <div className="steps-header-wrap">
          <h2 className="steps-main-title">
            Three Easy Steps To Your <span className="title-pink-accent">Life Partner</span>
          </h2>

          <div className="steps-divider-motif">
            <svg width="100" height="18" viewBox="0 0 100 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 9H34M66 9H100" stroke="#d4a373" strokeWidth="1" strokeLinecap="round" />
              <path d="M42 9C42 6.5 45 4.5 48 4.5C51 4.5 53 7 53 9C53 11 51 13.5 48 13.5C45 13.5 42 11.5 42 9Z" stroke="#d4a373" strokeWidth="1.2" fill="none" />
              <path d="M58 9C58 6.5 55 4.5 52 4.5C49 4.5 47 7 47 9C47 11 49 13.5 52 13.5C55 13.5 58 11.5 58 9Z" stroke="#d4a373" strokeWidth="1.2" fill="none" />
              <circle cx="50" cy="9" r="2.2" fill="#d4a373" />
            </svg>
          </div>

          <p className="steps-subtitle-text">
            Simple steps to meaningful connections and a lifetime of happiness.
          </p>
        </div>

        {/* Top Connecting Stepper Progress Line */}
        <div className="steps-progress-connector">
          <div className="connector-dashed-line" />
          <div className="connector-heart heart-pos-1">♥</div>
          <div className="connector-heart heart-pos-2">♥</div>

          {/* Badge 1 */}
          <div className="step-badge-anchor badge-pos-1">
            <div className="step-badge-outer-ring ring-pink">
              <div className="step-number-badge badge-pink">
                01
                <span className="badge-triangle triangle-pink" />
              </div>
            </div>
          </div>

          {/* Badge 2 */}
          <div className="step-badge-anchor badge-pos-2">
            <div className="step-badge-outer-ring ring-pink">
              <div className="step-number-badge badge-pink">
                02
                <span className="badge-triangle triangle-pink" />
              </div>
            </div>
          </div>

          {/* Badge 3 */}
          <div className="step-badge-anchor badge-pos-3">
            <div className="step-badge-outer-ring ring-pink">
              <div className="step-number-badge badge-pink">
                03
                <span className="badge-triangle triangle-pink" />
              </div>
            </div>
          </div>
        </div>

        {/* 3 Step Cards Grid */}
        <div className="three-cards-grid">
          {/* Card 1 */}
          <div className="step-luxury-card card-step-1">
            <div className="step-card-header-area">
              <div className="step-card-img-wrapper">
                <img src={step1Img} alt="Sign Up & Create Profile" className="step-card-img" />
                <svg className="step-curved-wave" viewBox="0 0 380 44" preserveAspectRatio="none">
                  <path d="M0,0 Q190,44 380,0 L380,44 L0,44 Z" fill="#ffffff" />
                  <path d="M0,0 Q190,44 380,0" fill="none" stroke="#f7a8b8" strokeWidth="2.5" />
                </svg>
              </div>

              {/* Floating Icon Badge */}
              <div className="step-floating-icon-badge icon-pink">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#d93367" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M17 11l2 2 4-4" />
                </svg>
              </div>
            </div>

            <div className="step-card-body">
              <h3 className="step-card-title title-pink">
                Sign Up &amp; Create<br />Your Profile
              </h3>
              <p className="step-card-desc">
                Register in just a few seconds and create a profile that truly represents you.
              </p>

              <div className="card-bottom-motif motif-pink">
                <svg width="120" height="16" viewBox="0 0 120 16" fill="none">
                  <path d="M10 8C25 8 35 3 48 3C53 3 55 8 57 8" stroke="#f7a8b8" strokeWidth="1" />
                  <path d="M110 8C95 8 85 3 72 3C67 3 65 8 63 8" stroke="#f7a8b8" strokeWidth="1" />
                  <circle cx="20" cy="8" r="1.5" fill="#f7a8b8" />
                  <circle cx="100" cy="8" r="1.5" fill="#f7a8b8" />
                  <path d="M60 12.5L58.5 11.2C54.5 7.8 52 5.5 52 3C52 1.3 53.3 0 55 0C56 0 57 0.5 57.5 1.2L60 3.5L62.5 1.2C63 0.5 64 0 65 0C66.7 0 68 1.3 68 3C68 5.5 65.5 7.8 61.5 11.2L60 12.5Z" fill="#d93367" />
                </svg>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="step-luxury-card card-step-2">
            <div className="step-card-header-area">
              <div className="step-card-img-wrapper">
                <img src={step2Img} alt="Find Compatible Matches" className="step-card-img" />
                <svg className="step-curved-wave" viewBox="0 0 380 44" preserveAspectRatio="none">
                  <path d="M0,0 Q190,44 380,0 L380,44 L0,44 Z" fill="#ffffff" />
                  <path d="M0,0 Q190,44 380,0" fill="none" stroke="#f7a8b8" strokeWidth="2.5" />
                </svg>
              </div>

              {/* Floating Icon Badge */}
              <div className="step-floating-icon-badge icon-pink">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#d93367" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
            </div>

            <div className="step-card-body">
              <h3 className="step-card-title title-pink">
                Find Compatible<br />Matches
              </h3>
              <p className="step-card-desc">
                Browse, filter &amp; discover people who align with your values and preferences.
              </p>

              <div className="card-bottom-motif motif-pink">
                <svg width="120" height="16" viewBox="0 0 120 16" fill="none">
                  <path d="M10 8C25 8 35 3 48 3C53 3 55 8 57 8" stroke="#f7a8b8" strokeWidth="1" />
                  <path d="M110 8C95 8 85 3 72 3C67 3 65 8 63 8" stroke="#f7a8b8" strokeWidth="1" />
                  <circle cx="20" cy="8" r="1.5" fill="#f7a8b8" />
                  <circle cx="100" cy="8" r="1.5" fill="#f7a8b8" />
                  <path d="M60 12.5L58.5 11.2C54.5 7.8 52 5.5 52 3C52 1.3 53.3 0 55 0C56 0 57 0.5 57.5 1.2L60 3.5L62.5 1.2C63 0.5 64 0 65 0C66.7 0 68 1.3 68 3C68 5.5 65.5 7.8 61.5 11.2L60 12.5Z" fill="#d93367" />
                </svg>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="step-luxury-card card-step-3">
            <div className="step-card-header-area">
              <div className="step-card-img-wrapper">
                <img src={step3Img} alt="Connect & Take The Next Step" className="step-card-img" />
                <svg className="step-curved-wave" viewBox="0 0 380 44" preserveAspectRatio="none">
                  <path d="M0,0 Q190,44 380,0 L380,44 L0,44 Z" fill="#ffffff" />
                  <path d="M0,0 Q190,44 380,0" fill="none" stroke="#f7a8b8" strokeWidth="2.5" />
                </svg>
              </div>

              {/* Floating Icon Badge */}
              <div className="step-floating-icon-badge icon-pink">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#d93367" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                  <path d="M12 12h.01" />
                </svg>
              </div>
            </div>

            <div className="step-card-body">
              <h3 className="step-card-title title-pink">
                Connect &amp; Take<br />The Next Step
              </h3>
              <p className="step-card-desc">
                Start conversations, build connections and take your journey forward.
              </p>

              <div className="card-bottom-motif motif-pink">
                <svg width="120" height="16" viewBox="0 0 120 16" fill="none">
                  <path d="M10 8C25 8 35 3 48 3C53 3 55 8 57 8" stroke="#f7a8b8" strokeWidth="1" />
                  <path d="M110 8C95 8 85 3 72 3C67 3 65 8 63 8" stroke="#f7a8b8" strokeWidth="1" />
                  <circle cx="20" cy="8" r="1.5" fill="#f7a8b8" />
                  <circle cx="100" cy="8" r="1.5" fill="#f7a8b8" />
                  <path d="M60 12.5L58.5 11.2C54.5 7.8 52 5.5 52 3C52 1.3 53.3 0 55 0C56 0 57 0.5 57.5 1.2L60 3.5L62.5 1.2C63 0.5 64 0 65 0C66.7 0 68 1.3 68 3C68 5.5 65.5 7.8 61.5 11.2L60 12.5Z" fill="#d93367" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Floating Pill Banner */}
        <div className="steps-bottom-pill-wrap">
          <div className="steps-bottom-pill">
            <div className="pill-heart-badge">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="#e53d5c">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
            </div>
            <span className="pill-text">
              Your perfect match could be just{" "}
              <strong className="pill-text-highlight">three steps away.</strong> 💖
            </span>
          </div>
        </div>
      </div>

      <style>{`
        .three-easy-steps-section {
          position: relative;
          padding: 75px 0 70px;
          background-color: #faf6f4;
          background-image: url(${stepsBg});
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          overflow: hidden;
        }

        .steps-inner-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
          position: relative;
          z-index: 2;
        }

        .steps-top-ornament {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 8px;
        }

        .steps-header-wrap {
          text-align: center;
          margin-bottom: 28px;
        }

        .steps-main-title {
          font-family: 'Playfair Display', Georgia, 'Times New Roman', serif;
          font-size: 2.45rem;
          font-weight: 700;
          color: #1e242d;
          margin: 0 0 6px;
          letter-spacing: -0.01em;
          line-height: 1.25;
        }

        .steps-main-title .title-pink-accent {
          color: #e53d5c;
          font-family: inherit;
          font-weight: 700;
        }

        .steps-divider-motif {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 8px 0 10px;
        }

        .steps-subtitle-text {
          font-family: 'Outfit', 'Plus Jakarta Sans', -apple-system, sans-serif;
          font-size: 1.02rem;
          color: #667085;
          margin: 0;
          font-weight: 400;
        }

        /* Stepper Progress Connector */
        .steps-progress-connector {
          position: relative;
          max-width: 1040px;
          margin: 0 auto 28px;
          height: 52px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          align-items: center;
        }

        .connector-dashed-line {
          position: absolute;
          top: 50%;
          left: 16%;
          right: 16%;
          height: 1.5px;
          border-top: 1.5px dashed rgba(229, 61, 92, 0.4);
          transform: translateY(-50%);
          z-index: 1;
        }

        .connector-heart {
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #e53d5c;
          font-size: 0.85rem;
          z-index: 2;
          background: #faf6f4;
          padding: 0 6px;
        }

        .heart-pos-1 {
          left: 33.3%;
        }

        .heart-pos-2 {
          left: 66.6%;
        }

        .step-badge-anchor {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          z-index: 3;
        }

        .step-badge-outer-ring {
          padding: 3px;
          border-radius: 50%;
          border: 1.5px dashed;
          background: #ffffff;
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
        }

        .ring-pink {
          border-color: #f7a8b8;
        }

        .ring-gold {
          border-color: #e5b869;
        }

        .ring-purple {
          border-color: #c49fe8;
        }

        .step-number-badge {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          font-family: 'Outfit', 'Plus Jakarta Sans', sans-serif;
          font-size: 1.05rem;
          font-weight: 700;
          position: relative;
        }

        .badge-pink {
          background: #d93367;
        }

        .badge-gold {
          background: #b8860b;
        }

        .badge-purple {
          background: #7c4d9f;
        }

        .badge-triangle {
          position: absolute;
          bottom: -6px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
        }

        .triangle-pink {
          border-top: 6px solid #d93367;
        }

        .triangle-gold {
          border-top: 6px solid #b8860b;
        }

        .triangle-purple {
          border-top: 6px solid #7c4d9f;
        }

        /* 3 Cards Grid */
        .three-cards-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 28px;
          margin-bottom: 42px;
        }

        .step-luxury-card {
          background: #ffffff;
          border-radius: 24px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          border: 1px solid #f2e9e9;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.35s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.35s ease;
        }

        .step-luxury-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 18px 40px rgba(0, 0, 0, 0.08);
        }

        .card-step-1:hover,
        .card-step-2:hover,
        .card-step-3:hover {
          border-color: rgba(217, 51, 103, 0.4);
        }

        /* Card Media Area */
        .step-card-header-area {
          position: relative;
          width: 100%;
        }

        .step-card-img-wrapper {
          position: relative;
          width: 100%;
          height: 230px;
          overflow: hidden;
          border-top-left-radius: 23px;
          border-top-right-radius: 23px;
          background: #f7f3f3;
        }

        .step-card-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center center;
          display: block;
          transition: transform 0.45s ease;
        }

        .step-luxury-card:hover .step-card-img {
          transform: scale(1.04);
        }

        .step-curved-wave {
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          height: 38px;
          z-index: 2;
          pointer-events: none;
        }

        .step-floating-icon-badge {
          position: absolute;
          bottom: -22px;
          left: 50%;
          transform: translateX(-50%);
          width: 58px;
          height: 58px;
          border-radius: 50%;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 5;
          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
        }

        .icon-pink {
          border: 2.5px solid #ffccd5;
        }

        .icon-gold {
          border: 2.5px solid #f7e6c4;
        }

        .icon-purple {
          border: 2.5px solid #e5d4f3;
        }

        /* Card Body */
        .step-card-body {
          padding: 36px 24px 28px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1;
        }

        .step-card-title {
          font-family: 'Outfit', 'Plus Jakarta Sans', -apple-system, sans-serif;
          font-size: 1.22rem;
          font-weight: 700;
          line-height: 1.35;
          margin: 0 0 12px;
        }

        .title-pink {
          color: #d93367;
        }

        .title-gold {
          color: #b8860b;
        }

        .title-purple {
          color: #7c4d9f;
        }

        .step-card-desc {
          font-family: 'Outfit', 'Plus Jakarta Sans', -apple-system, sans-serif;
          font-size: 0.94rem;
          color: #64748b;
          line-height: 1.62;
          margin: 0 0 20px;
          max-width: 290px;
          flex: 1;
        }

        .card-bottom-motif {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: auto;
        }

        /* Bottom Floating Pill */
        .steps-bottom-pill-wrap {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .steps-bottom-pill {
          display: inline-flex;
          align-items: center;
          gap: 14px;
          background: #ffffff;
          border: 1px solid #fce8ec;
          border-radius: 999px;
          padding: 10px 32px 10px 18px;
          box-shadow: 0 8px 24px rgba(229, 61, 92, 0.08);
          transition: transform 0.3s ease;
        }

        .steps-bottom-pill:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 30px rgba(229, 61, 92, 0.14);
        }

        .pill-heart-badge {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background: #fff0f3;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .pill-text {
          font-family: 'Outfit', 'Plus Jakarta Sans', -apple-system, sans-serif;
          font-size: 1.02rem;
          color: #2b354f;
          font-weight: 500;
        }

        .pill-text-highlight {
          color: #e53d5c;
          font-family: 'Playfair Display', Georgia, serif;
          font-style: italic;
          font-weight: 700;
        }

        @media (max-width: 991px) {
          .three-cards-grid {
            grid-template-columns: 1fr;
            max-width: 460px;
            margin: 0 auto 36px;
          }

          .steps-progress-connector {
            display: none;
          }

          .steps-main-title {
            font-size: 1.95rem;
          }
        }

        @media (max-width: 768px) {
          .three-easy-steps-section {
            padding: 50px 0 42px;
          }

          .steps-main-title {
            font-size: 1.65rem;
          }

          .steps-subtitle-text {
            font-size: 0.92rem;
          }

          .steps-bottom-pill {
            padding: 8px 20px;
          }

          .pill-text {
            font-size: 0.88rem;
          }
        }
      `}</style>
    </section>
  );
};

export default ThreeEasySteps;
